/** Content for the Ferring × Snakker REKOVELLE presentation. Screens refer to teaser Snak still indexes (0 Hook … 5 Proof). */

export const experiencedSteps = [
  { label: 'Clinical tension', detail: 'Two patients. Same approach?', screen: 0 },
  { label: 'Interaction', detail: 'Move AMH and body weight', screen: 2 },
  { label: 'Reveal', detail: 'An individualized starting dose', screen: 3, highlight: true },
  { label: 'Product benefit', detail: 'Calculated for the patient. Set on the pen.', screen: 4 },
  { label: 'Next step', detail: 'Continue to the evidence', screen: 5 },
]

export const modelColumns = [
  {
    title: 'Attention',
    lead: 'Earn the first 30–60 seconds.',
    body: 'Start with a question, tension, prediction or challenge — rather than another product claim.',
  },
  {
    title: 'Understanding',
    lead: 'Make the HCP participate.',
    verbs: ['Choose', 'Predict', 'Slide', 'Compare', 'Explore'],
    body: 'The product story becomes something experienced rather than simply explained.',
  },
  {
    title: 'Action',
    lead: 'Reward the interaction with a useful next step.',
    verbs: ['Evidence', 'Study', 'Booking', 'Rep conversation', 'Guidelines', 'Product information'],
  },
]

export const journeyStages = [
  { title: 'Promise', ask: 'Give me a reason to spend the next 30 seconds.', example: '“Same goal. Same starting approach?”', screen: 0 },
  { title: 'Effort', ask: 'Give me one simple thing to do.', example: 'Explore the patient — AMH and weight', screen: 2 },
  { title: 'Reward', ask: 'Give me an answer, reveal, comparison or insight.', example: 'The individualized dosing reveal', screen: 3 },
  { title: 'Next step', ask: 'Give me somewhere useful to go next.', example: 'Evidence and product information', screen: 5 },
]

export const snakifyUseCases = [
  { label: 'Individualized dosing', hint: 'The one you just played', played: true },
  { label: 'New study / data update', hint: 'Predict the result, then reveal it' },
  { label: 'Patient profiles', hint: 'Which patient is this for?' },
  { label: 'Safety / OHSS', hint: 'Spot the risk before it happens' },
  { label: 'Pen & administration', hint: 'Set the dose yourself' },
  { label: 'Guidelines / protocols', hint: 'Test your protocol choices' },
  { label: 'Congress data', hint: 'One finding, one minute' },
  { label: 'Peer behaviour', hint: 'What do colleagues do?' },
  { label: 'Nurse education', hint: 'Practice, not reading' },
  { label: 'Patient support', hint: 'Simple steps, made tangible' },
]

export const channelOrbit = [
  'Email',
  'Banner',
  'Website',
  'WhatsApp',
  'IVA / Veeva',
  'F2F',
  'Congress',
  'Symposium',
  'QR / Leave-behind',
]

export const conversationApps = [
  { moment: 'Before', title: 'Congress opener', body: 'A provocative question or challenge, accessible by QR.' },
  { moment: 'During', title: 'Live peer poll', body: 'What would you do? Audience answers → live aggregate → speaker discussion.' },
  { moment: 'During', title: 'F2F / IVA', body: 'A rep starts with an interaction rather than another slide.' },
  { moment: 'After', title: 'Follow-up', body: 'The HCP continues the experience after the meeting.' },
]

export const teaserSignals = [
  { question: 'Did they start?', screen: 'Hook' },
  { question: 'How did they answer the opening question?', screen: 'Hook' },
  { question: 'Which patient profile did they explore?', screen: 'Mini-sim' },
  { question: 'How did they interact with AMH / weight?', screen: 'Mini-sim' },
  { question: 'Did they reach the REKOVELLE reveal?', screen: 'Reveal' },
  { question: 'Did they continue to the evidence?', screen: 'Proof' },
  { question: 'Did they take the CTA?', screen: 'Proof' },
]

export const broaderSignals = [
  'Beliefs',
  'Preferences',
  'Confidence',
  'Knowledge gaps',
  'Treatment choices',
  'Peer comparisons',
  'Content interest',
]

export const campaignLoop = [
  { node: 'Hook', channel: 'Email / banner', example: '“Same goal. Same starting approach?”' },
  { node: 'Snak', channel: 'Interactive teaser', example: 'Individualized dosing principle.' },
  { node: 'Signal', channel: 'Signal', example: 'Who engaged — and what interested them?' },
  { node: 'Next message', channel: 'Relevant follow-up', example: 'Evidence · safety · patient profile · administration.' },
  { node: 'Next Snak', channel: 'Rep / IVA / congress', example: 'The conversation continues — in person.' },
]

export const learningAreas = [
  { title: 'Message', question: 'What earns attention?' },
  { title: 'Channel', question: 'Where do HCPs actually engage?' },
  { title: 'Audience', question: 'What interests different HCP groups?' },
  { title: 'Market', question: 'What works similarly — or differently — across countries?' },
]

/** Illustrative peer distribution for the hook question — not real data. */
export const peerAnswers = [
  { label: 'No — individualize', share: 71, you: true },
  { label: 'Yes — same approach', share: 29 },
]

export const peerSteps = ['Answer', 'Commit', 'Compare', 'Learn']

export const executionSteps = ['Message', 'Snak', 'Localize', 'Activate', 'Measure', 'Optimize']

export const executionSupport = [
  'Concept',
  'Build',
  'Adaptation',
  'Localization',
  'Channel activation',
  'Reporting',
  'Optimization',
]

export const closingQuestions = [
  { title: 'What message?', options: ['Dosing', 'Evidence', 'Safety', 'Administration', 'Other'] },
  { title: 'Where?', options: ['Email', 'Congress', 'IVA', 'Website', 'F2F'] },
  { title: 'What should we learn?', options: ['Attention', 'Understanding', 'Preference', 'Behaviour', 'Next action'] },
]
